import { ToastOptions } from 'ng2-toastr';

export class CustomToastrOption extends ToastOptions {
    positionClass = "toast-bottom-right";
}


// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/probox-dev/src/app/shared/custom-configurations/toastr-custom-options.ts